<template>
  <div class="register-wrap">
    <authLeft />
    <div class="register-right">
      <div class="register-form">
        <div class="register-form-title">パスワード再設定</div>
        <el-form :model="form" :rules="rules" ref="form" @submit.native.prevent="resetPassword">
          <div class="register-form-subtitle">メールアドレス</div>
          <el-form-item prop="currentEmail">
            <el-input placeholder="登録メールアドレスを入力して下さい" v-model="form.currentEmail" autocomplete="off"></el-input>
          </el-form-item>
          <el-button style="width:100%; margin-top:10px;" type="primary" @click="resetPassword" :disabled="loading || !isEmailValid">
            <div class="flex-row">
              パスワード再設定メールを送信
              <div class="loader--mini" v-show="loading"></div>
            </div>
          </el-button>
          <router-link to="/login">
            <div style="margin:40px 0px" class="router-link">ログインはこちら</div>
          </router-link>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import authLeft from "./auth_left";
const root = process.env.VUE_APP_API;
const passwordResetAPI = root + "/api/auth/passwordreset";
const protocol = window.location.protocol; // "http:" または "https:"
const hostname = window.location.hostname; // "127.0.0.1"
const port = window.location.port; // "8080"
const fullUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`;

export default {
  name: "password_reset",
  components: {
    authLeft,
  },
  data() {
    return {
      loading: false,
      form: {
        currentEmail: "",
      },
      isEmailValid: false,
      rules: {
        currentEmail: [
          { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
          { type: 'email', message: '正しいメールアドレス形式で入力してください', trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    resetPassword() {
      this.loading = true;
      var params = new URLSearchParams();
      var currentEmail = this.form.currentEmail.trim();//ノーブレークスペース削除      
      params.append("email", currentEmail);
      params.append("accessUrl", fullUrl);
      this.axios
        .post(passwordResetAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.loading = false;
            this.$alert(response.data.email + "宛にパスワードリセットメールを送信しました。", "パスワードリセットメールを送信しました", {
              confirmButtonText: "OK",
            });
          } else if (response.data.status == "firebase_error") {
            this.loading = false;
            this.$alert("エラーが発生しました。しばらく時間を空けてお試しいただくか、担当者までご連絡ください。", "", {
              confirmButtonText: "OK",
            });
          } else if (response.data.status == "wrong_email_error") {
            this.loading = false;
            this.$alert("登録されていないメールアドレスです。", "", {
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("登録されていないメールアドレスです");
        });
    },
  },
  watch: {
    'form.currentEmail'(val) {
      // 入力が変わるたびにバリデーションを実行
      this.$refs.form.validateField('currentEmail', valid => {
        this.isEmailValid = valid === '';
      });
    }
  }
};
</script>
